import { useEffect, useState } from "react";
import api from "../../shared/utils/request";
import { Link } from "react-router-dom";
import PageLoader from "../shared/pageLoader";
import toast from "react-hot-toast";
import LoginWarning, { EmptyCart } from "../shared/warningPages";
import MobileCheckoutBar from "../shared/mobileCheckoutBar/MobileCheckoutBar";
import { usePageSeo } from "../../shared/seo";
import { useCart } from "../../shared/context/CartContext";

const CartPage = () => {
  usePageSeo("cart");
  const { syncCartCount } = useCart();

  const [cartDatas, setCartDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addToCartLoading, setAddToCartLoading] = useState({});
  const [minusLoading, setMinusLoading] = useState({});
  const isToken = localStorage.getItem("token");
  const [cartTotal, setCartTotal] = useState(0);

  useEffect(() => {
    const getCartDatas = async () => {
      setLoading(true);
      try {
        const data = await api.post("customer/getCartList");
        setCartDatas(data?.cartItems);
        setCartTotal({
          cart_sub_total_amount: data?.cart_sub_total_amount,
          cart_total_amount: data?.cart_total_amount,
          total_tax: data?.total_tax,
        });
        syncCartCount(data?.cart_total_items);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch cart data:", error);
      } finally {
        setLoading(false);
      }
    };

    getCartDatas();
  }, [syncCartCount]);

  const handleQuantityChange = async (
    cartId,
    newQuantity,
    productId,
    variantId,
    action,
  ) => {
    try {
      if (action === "add") {
        setAddToCartLoading((prev) => ({ ...prev, [cartId]: true }));
      } else if (action === "minus") {
        setMinusLoading((prev) => ({ ...prev, [cartId]: true }));
      }
      const response = await api.post("customer/updateCart", {
        cart_id: cartId,
        quantity: newQuantity,
        product_id: productId,
        variant_id: variantId,
      });

      if (response?.status) {
        // Update the cart data in the state
        if (newQuantity === 0) {
          toast.success(response?.message);
          setCartDatas((prevCartDatas) =>
            prevCartDatas.filter((item) => item.cart_id !== cartId),
          );
        } else {
          setCartDatas((prevCartDatas) =>
            prevCartDatas.map((item) =>
              item.cart_id === cartId
                ? { ...item, quantity: newQuantity }
                : item,
            ),
          );
        }
        setAddToCartLoading((prev) => ({ ...prev, [cartId]: false }));
        setCartTotal({
          cart_sub_total_amount: response?.cart_sub_total_amount,
          cart_total_amount: response?.cart_total_amount,
          total_tax: response?.total_tax,
        });
        syncCartCount(response?.cart_total_items);
        setMinusLoading((prev) => ({ ...prev, [cartId]: false }));
      }
    } catch (error) {
      setAddToCartLoading((prev) => ({ ...prev, [cartId]: false }));
      setMinusLoading((prev) => ({ ...prev, [cartId]: false }));
      console.error("Failed to update cart:", error);
    }
  };

  if (!isToken && !loading) {
    return <LoginWarning />;
  }

  if (!loading && cartDatas?.length === 0) {
    return <EmptyCart />;
  }

  return (
    <>
      {loading && <PageLoader />}
      <section className="cart py-80 page-with-mobile-checkout">
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-xl-9 col-lg-8">
              <div className="cart-table border border-gray-100 rounded-8 px-20 py-24">
                <div className="overflow-x-auto scroll-sm scroll-sm-horizontal cart-table-scroll">
                  <table className="table style-three">
                    <thead>
                      <tr>
                        <th className="h6 mb-0 text-lg fw-bold">Delete</th>
                        <th className="h6 mb-0 text-lg fw-bold">
                          Product Name
                        </th>
                        <th className="h6 mb-0 text-lg fw-bold">Price</th>
                        <th className="h6 mb-0 text-lg fw-bold">Quantity</th>
                        <th className="h6 mb-0 text-lg fw-bold">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartDatas?.map((cartData) => (
                        <tr key={cartData?.cart_id}>
                          <td data-label="Action" className="mob-action">
                            <button
                              onClick={() => {
                                handleQuantityChange(
                                  cartData?.cart_id,
                                  0,
                                  cartData?.product_id,
                                  cartData?.variant_id,
                                );
                              }}
                              type="button"
                              className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
                            >
                              <i className="ph ph-x-circle text-2xl d-flex hover-text-danger-600" />
                            </button>
                          </td>
                          <td data-label="Product">
                            <div className="table-product cart-product-row d-flex align-items-center gap-24">
                              <Link
                                // to={`/product-details?product_id=${cartData?.product_id}`}
                                to={`#`}
                                className="table-product__thumb border border-gray-100 rounded-8 flex-center"
                              >
                                <img
                                  src={cartData?.image}
                                  alt={cartData?.product_name}
                                />
                              </Link>
                              <div className="table-product__content text-start">
                                <h6 className="title text-lg fw-semibold mb-8">
                                  <Link
                                    to={`#`}
                                    className="link text-line-2"
                                    tabIndex={0}
                                  >
                                    {cartData?.title}
                                  </Link>
                                </h6>
                                {/* <div className="flex-align gap-16 mb-16">
                                <div className="flex-align gap-6">
                                  <span className="text-md fw-medium text-warning-600 d-flex">
                                    <i className="ph-fill ph-star" />
                                  </span>
                                  <span className="text-md fw-semibold text-gray-900">
                                    4.8
                                  </span>
                                </div>
                                <span className="text-sm fw-medium text-gray-200">
                                  |
                                </span>
                                <span className="text-neutral-600 text-sm">
                                  128 Reviews
                                </span>
                              </div> */}
                              </div>
                            </div>
                          </td>
                          <td data-label="Price">
                            <span className="text-lg h6 mb-0 fw-semibold">
                              ₹{cartData?.sale_price}
                            </span>
                          </td>
                          <td data-label="Quantity">
                            <div className="d-flex rounded-4 overflow-hidden">
                              <button
                                key={"minus-" + cartData?.cart_id}
                                onClick={() =>
                                  handleQuantityChange(
                                    cartData?.cart_id,
                                    cartData?.quantity - 1,
                                    cartData?.product_id,
                                    cartData?.variant_id,
                                    "minus",
                                  )
                                }
                                disabled={
                                  cartData?.quantity <= 1 ||
                                  minusLoading[cartData?.cart_id]
                                }
                                type="button"
                                className="quantity__minus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
                              >
                                {minusLoading[cartData?.cart_id] ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  <i className="ph ph-minus" />
                                )}
                              </button>
                              <input
                                type="number"
                                className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-4"
                                value={cartData?.quantity}
                                min={1}
                              />
                              <button
                                key={"add-" + cartData?.cart_id}
                                onClick={() =>
                                  handleQuantityChange(
                                    cartData?.cart_id,
                                    cartData?.quantity + 1,
                                    cartData?.product_id,
                                    cartData?.variant_id,
                                    "add",
                                  )
                                }
                                type="button"
                                disabled={
                                  cartData?.stock <= cartData?.quantity ||
                                  addToCartLoading[cartData?.cart_id]
                                }
                                className="quantity__plus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
                              >
                                {addToCartLoading[cartData?.cart_id] ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  <i className="ph ph-plus" />
                                )}
                              </button>
                            </div>
                          </td>
                          <td data-label="Total">
                            <span className="text-lg h6 mb-0 fw-semibold">
                              ₹{cartData?.sale_price * cartData?.quantity}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4">
              <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">
                <h6 className="text-xl mb-32">Cart Totals</h6>
                <div className="bg-color-three rounded-8 p-24">
                  <div className="mb-32 flex-between gap-8">
                    <span className="text-gray-900 font-heading-two">
                      Subtotal
                    </span>
                    <span className="text-gray-900 fw-semibold">
                      ₹{cartTotal?.cart_sub_total_amount}
                    </span>
                  </div>
                  <div className="mb-32 flex-between gap-8">
                    <span className="text-gray-900 font-heading-two">
                      Total Tax
                    </span>
                    <span className="text-gray-900 fw-semibold">
                      ₹{cartTotal?.total_tax}
                    </span>
                  </div>
                  <div className="mb-32 flex-between gap-8">
                    <span className="text-gray-900 font-heading-two">
                      Shipping Charge
                    </span>
                    <span className="text-gray-900 fw-semibold">Free</span>
                  </div>
                </div>
                <div className="bg-color-three rounded-8 p-24 mt-24">
                  <div className="flex-between gap-8">
                    <span className="text-gray-900 text-xl fw-semibold">
                      Total
                    </span>
                    <span className="text-gray-900 text-xl fw-semibold">
                      ₹{cartTotal?.cart_total_amount}
                    </span>
                  </div>
                </div>
                <Link
                  to="/checkout"
                  className="btn btn-main mt-40 py-18 w-100 rounded-8 d-none d-lg-block"
                >
                  Proceed to checkout
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <MobileCheckoutBar total={cartTotal?.cart_total_amount} to="/checkout" />
    </>
  );
};
export default CartPage;
